import * as Sentry from '@sentry/react';
import { parseJwt, auth } from './base-ui/lib';

export const updateSentryUser = () => {
	const token = auth.getBearerToken();

	if (token) {
		try {
			const decoded = parseJwt(token);

            console.log('setting sentry user');
			Sentry.setUser({
				id: decoded.sub
			});

		} catch (error) {
			console.error('Failed to decode JWT:', error);
			Sentry.setUser(null);
		}

        return
	}
    
	Sentry.setUser(null);
};
